import { CategoriasControllerApi, MarcaControllerApi, UsuariosControllerApi, settings} from '@api/backend'
import {displaySuccessMsg, displayErrorMsg} from '@src/utility/Utils'
import { handleLogin } from '@store/actions/auth'
import { LogOut } from 'react-feather'

const prefix = 'usuarios'

export const GET_USUARIO = `${prefix}/GET_DATA_USUARIO`
export const GET_USUARIOS = `${prefix}/GET_DATA`
export const GET_USUARIOS_COUNT = `${prefix}/GET_DATA_COUNT`
export const ADD_USUARIO = `${prefix}/ADD`
export const DELETE_USUARIO = `${prefix}/DELETE`
export const UPDATE_USUARIO = `${prefix}/UPDATE`
export const INIT_DATA_NECESARIA = `${prefix}/INIT_DATA_NECESARIA`

const apiUsuarios = new UsuariosControllerApi(settings)
const apiMarca = new MarcaControllerApi(settings)
const apiCategorias = new CategoriasControllerApi(settings)


// ** Get all Data
export const getData = params => {
  return async (dispatch, getState) => {
    try {

      const {page = 1, perPage = 10, sortBy = "", q = ""} = params
      const empresaId = getState().layout.selectedEmpresaId

      const filter =  {
        offset: (page - 1) * perPage,
        limit: perPage,
        skip: ((page - 1) * perPage),
        order: sortBy || "nombre ASC",
        where: {
          ['empresaId']: {eq: `${empresaId}`},
          ['or'] : [
            {['nombre']: {like: `%${q}%`, options: 'i'}},
            {['codigo']: {like: `%${q}%`, options: 'i'}},
            {['mail']: {like: `%${q}%`, options: 'i'}}
          ]
        },
        include: [
          {
            relation: 'roles'
          }
        ]
      }

      const {data: dataUsuarios} = await apiUsuarios.usuariosControllerFind(JSON.stringify(filter))
      const {data: dataUsuariosCount} = await apiUsuarios.usuariosControllerCount(JSON.stringify(filter.where))

      dispatch({
        type: GET_USUARIOS,
        usuarios: dataUsuarios,
        total: dataUsuariosCount.count || 0
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const addUsuario = (usuario, intl) => {
  return async (dispatch) => {
    try {
      const {data} = await apiUsuarios.usuariosControllerCreate(usuario)
      displaySuccessMsg(intl.formatMessage({ id: 'Usuario creado' }))
      dispatch({
        type: ADD_USUARIO,
        data
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const updateUsuario = (id, usuario, intl) => {
  return async (dispatch) => {
    try {
      const {data} = await apiUsuarios.usuariosControllerUpdateById(id, usuario)
      displaySuccessMsg(intl.formatMessage({ id: 'Usuario actualizado' }))
      dispatch({
        type: UPDATE_USUARIO,
        data
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const deleteUsuario = (usuarioId, intl) => {
  return async (dispatch) => {
    try {
      await apiUsuarios.usuariosControllerDeleteById(usuarioId)
      displaySuccessMsg(intl.formatMessage({ id: 'Usuario eliminado' }))
      dispatch({
        type: DELETE_USUARIO,
        data: usuarioId
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const getUsuario = (usuario) => {
  return async (dispatch) => {
    try {
      // const filter = {
      //   include: ['roles']
      // }
      const {data: dataUsuario} = await apiUsuarios.usuariosControllerFindById(usuario)
      dispatch({
        type: GET_USUARIO,
        selectedUsuario: dataUsuario
      })
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const initUsuario = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_USUARIO,
      selectedCompany: null
    })
  }
}

// O B T E N E R - D A T O S - M A R C A  - C A T E G O R I A
export const getDatosMarca = async () => {
  try {
    const { data: dataMarcas } = await apiMarca.marcaControllerFind()
    if (dataMarcas.length === 0) {
      return []
    } else {
      return dataMarcas
    }
  } catch (err) {
    console.error(err.message)
    return [] // en caso de error también devuelves un array vacío
  }
}

export const getDatosCategoria = async () => {
  try {
    const { data: dataCategorias } = await apiCategorias.categoriasControllerFind()
    if (dataCategorias.length === 0) {
      return []
    } else {
      return dataCategorias
    }
  } catch (err) {
    console.error(err.message)
    return [] // en caso de error también devuelves un array vacío
  }
}

// Función auxiliar para configurar la sesión de un usuario (impersonado u original)
const configurarSesionUsuario = async (dispatch, user) => {
  // Guardar sesión en localStorage
  localStorage.setItem("userDataPim", JSON.stringify(user))
  localStorage.setItem("accessToken", user.accessToken)
  localStorage.setItem("refreshToken", user.refreshToken)

  // Reiniciar la sesión en Redux
  await dispatch(handleLogin(user))
}

export const loginComoOtroUsuario = (userId, intl) => {
  return async (dispatch) => {
    try {
      const response = await apiUsuarios.usuariosControllerAccederComoOtroUsuario(userId)

      // Guardar sesión original
      const sessionOriginal = {
        userDataPim: localStorage.getItem("userDataPim"),
        accessToken: localStorage.getItem("accessToken"),
        refreshToken: localStorage.getItem("refreshToken")
      }
      localStorage.setItem("sessionOriginal", JSON.stringify(sessionOriginal))
      localStorage.setItem("impersonando", "true")

      if (response?.data?.user) {
        const user = {
          ...response.data.user,
          accessToken: response.data.accessToken,
          refreshToken: response.data.refreshToken,
          impersonado: true,
          impersonadoPor: response.data.impersonadoPor
        }

        await configurarSesionUsuario(dispatch, user)
        return response.data
      } else {
        console.log("No se encontró el usuario")
        displayErrorMsg(intl.formatMessage({ id: "No user found" }))
      }
    } catch (error) {
      console.error("Error al impersonar:", error)
      displayErrorMsg(intl.formatMessage({ id: "Error impersonating user" }))
    }
  }
}

export const volverAUsuarioOriginal = (intl) => {
  return async (dispatch) => {
    try {
      const sessionOriginal = JSON.parse(localStorage.getItem("sessionOriginal"))

      if (!sessionOriginal) {
        console.error("No hay sesión original guardada")
        displayErrorMsg(intl.formatMessage({ id: "No original session saved" }))
        return
      }

      // Restaurar sesión original
      const user = JSON.parse(sessionOriginal.userDataPim)

      // user.accessToken = JSON.parse(sessionOriginal.accessToken)  // quita las comillas
      // user.refreshToken = JSON.parse(sessionOriginal.refreshToken)
      // // user.accessToken = sessionOriginal.accessToken
      // user.refreshToken = sessionOriginal.refreshToken

      // Limpiar datos de impersonación
      localStorage.removeItem("sessionOriginal")
      localStorage.removeItem("impersonando")

      await configurarSesionUsuario(dispatch, user, intl)

      //window.location.replace("/") // asegurar estado limpio
    } catch (error) {
      console.error("Error al volver a usuario original:", error)
      displayErrorMsg(intl.formatMessage({ id: "Error returning to original user" }))
    }
  }
}

export const BotonFlotanteUsuarioImpersonado = ({ onClick, intl }) => {
  const buttonStyle = {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 9999,
    backgroundColor: "#dc3545", // rojo alerta
    color: "#fff",
    border: "none",
    borderRadius: "30px",
    padding: "12px 20px",
    fontSize: "14px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
    animation: "pulse 2s infinite"
  }

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7) }
            70% { box-shadow: 0 0 0 12px rgba(220, 53, 69, 0) }
            100% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0) }
          }
        `}
      </style>
      <button style={buttonStyle} onClick={onClick}>
        <LogOut size={18} />
        {intl.formatMessage({ id: 'Return to my original session' })}
      </button>
    </>
  )
}